import React, { useState } from "react";
import Input from "../../../../../components/form-components/Input";

const OAuthForm = ({ sourceType, formData, onChange }) => {
  const isConnected = !!formData.oauth_token;
  const [showTokenInput, setShowTokenInput] = useState(false);
  const [tokenValue, setTokenValue] = useState("");

  const handleConfirm = () => {
    if (!tokenValue.trim()) return;
    onChange({ ...formData, oauth_token: tokenValue.trim(), oauth_connected: true });
  };

  return (
    <div>
      <div className="mb-5">
        <label className="block text-sm font-medium text-text-2 mb-2">Authentication</label>
        <div className="border border-border rounded-ctrl p-6 bg-surface-2">
          {isConnected ? (
            <div className="text-center">
              <div className="w-10 h-10 rounded-full bg-success-soft flex items-center justify-center mx-auto mb-3">
                <span className="text-success text-lg">✓</span>
              </div>
              <div className="text-sm font-medium text-text mb-1">Connected to {sourceType.name}</div>
              <div className="text-xs text-text-2 mb-3">Authorization successful. You can proceed.</div>
              <button
                type="button"
                className="text-xs text-primary hover:underline"
                onClick={() => {
                  setShowTokenInput(false);
                  setTokenValue("");
                  onChange({ ...formData, oauth_token: "", oauth_connected: false });
                }}
              >
                Disconnect
              </button>
            </div>
          ) : !showTokenInput ? (
            <div className="text-center">
              <p className="text-sm text-text-2 mb-4">
                Provide an access token to authorize access to your {sourceType.name} team analytics data.
              </p>
              <button
                type="button"
                className="bg-primary hover:bg-primary-hover text-white px-6 py-2.5 rounded-ctrl text-sm font-medium transition-colors"
                onClick={() => setShowTokenInput(true)}
              >
                Connect with {sourceType.name} →
              </button>
              <div className="text-[11px] text-text-2 mt-3">
                Requires a {sourceType.name} Team Admin or Owner access token.
              </div>
            </div>
          ) : (
            <div>
              <div className="text-sm font-medium text-text mb-3">Enter {sourceType.name} Access Token</div>
              <Input
                title=""
                name="oauth_token"
                type="password"
                value={tokenValue}
                onChange={(e) => setTokenValue(e.target.value)}
                placeholder="Paste your access token here"
              />
              <p className="text-[11px] text-text-2 -mt-5 mb-4">
                Find this in {sourceType.name} → Settings → API / Access Tokens. Requires Team Admin role.
              </p>
              <div className="flex items-center gap-3">
                <button
                  type="button"
                  className="bg-primary hover:bg-primary-hover text-white px-5 py-2 rounded-ctrl text-sm font-medium transition-colors disabled:opacity-50"
                  onClick={handleConfirm}
                  disabled={!tokenValue.trim()}
                >
                  Verify & Connect
                </button>
                <button
                  type="button"
                  className="text-sm text-text-2 hover:text-text"
                  onClick={() => {
                    setShowTokenInput(false);
                    setTokenValue("");
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {sourceType.dataTypes.length > 0 && (
        <div className="mb-5">
          <label className="block text-sm font-medium text-text-2 mb-2">Data to Import</label>
          <div className="flex flex-col gap-2">
            {sourceType.dataTypes.map((dt) => (
              <label
                key={dt.id}
                className="flex items-center gap-2.5 p-2.5 border border-border rounded-ctrl cursor-pointer text-sm text-text hover:bg-surface-2"
              >
                <input
                  type="checkbox"
                  checked={formData.dataTypes?.includes(dt.id) ?? dt.default}
                  onChange={(e) => {
                    const current = formData.dataTypes || sourceType.dataTypes.filter((d) => d.default).map((d) => d.id);
                    const updated = e.target.checked
                      ? [...new Set([...current, dt.id])]
                      : current.filter((id) => id !== dt.id);
                    onChange({ ...formData, dataTypes: updated });
                  }}
                  className="accent-primary"
                />
                {dt.label}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default OAuthForm;
